import { Router, ActivatedRoute } from '@angular/router';
import { Component, OnInit, OnDestroy, ViewChild } from '@angular/core';
import { CommonMethodService } from '../../common/commonMethod.service';
import { ToastrService } from 'ngx-toastr';
import { Subscription } from 'rxjs';
import { ModalDirective } from 'ngx-bootstrap/modal';
import { AppUtility } from '../../common/apputility';
import { ResidentService } from '../../services/resident.service';
import { UserService } from '../../services/user.service';

@Component({
  selector: 'app-vehicle-list',
  templateUrl: './vehicle-list.component.html',
  // styleUrls: ['./vehicle-list.component.css']
  providers: [CommonMethodService, ResidentService, UserService]
})
export class VehicleListComponent implements OnInit, OnDestroy {

  @ViewChild('primaryModal') public primaryModal: ModalDirective;
  @ViewChild('primaryModal1') public primaryModal1: ModalDirective;
  @ViewChild('primaryModal2') public primaryModal2: ModalDirective;

  subscribe: Array<Subscription> = [];
  pageable: any;
  searchBy: string = '';
  loader: boolean = false;

  accountId: number;
  flatId: number;

  // Vehicle
  vehicleInfoList: Array<any> = [];

  vehicleId: number;
  vehicleNo: string;
  vehicleCompanyName: string;
  imageName: string = '';


  constructor(private toaster: ToastrService, private residentService: ResidentService, private activeRoute: ActivatedRoute,
    private route: Router, private commonMethod: CommonMethodService, private userService: UserService) { }

  ngOnInit() {
    this.accountId = (Number)(sessionStorage.getItem('accountId'));
    this.flatId = (Number)(sessionStorage.getItem('flatId'));
    this.pageable = {
      currentPage: 1,
      itemsPerPage: 10,
      totalItems: 0
    };
    this.activeRoute.queryParams.subscribe(
      params => {
        this.loader = true;
        this.pageable.currentPage = params['page'] ? params['page'] : 1;
        this.subscribe.push(this.residentService.getVehicleList(this.accountId, this.flatId).subscribe(
          data => {
            this.loader = false;
            this.vehicleInfoList = JSON.parse(JSON.stringify(data));
          }, error => {
            this.loader = false;
            this.commonMethod.returnErrorMessage(error);
          }));
      }
    );
  }

  //Add Vehicle

  registerVehicle(): void {

    if (AppUtility.isEmptyString(this.vehicleNo)) {
      this.toaster.error('Please enter vehicle no.');
      return;
    }
    if (this.vehicleNo.length > 30) {
      this.toaster.error('Vehicle no max length is 30 charactors.');
      return;
    }
    if (AppUtility.isEmptyString(this.vehicleCompanyName)) {
      this.toaster.error('Please enter vehicle Make.');
      return;
    }

    let details: any = {};
    details.accountId = this.accountId;
    details.vehicleNo = this.vehicleNo;
    details.id = this.vehicleId;
    details.premiseHierarchyDetailsId = this.flatId;
    details.vehicleCompanyName = this.vehicleCompanyName;

    this.loader = true;
    this.subscribe.push(this.residentService.registerCommercialVehicle(details).subscribe(
      data => {
        this.loader = false;
        this.primaryModal.hide();
        this.ngOnInit();
        if (this.vehicleId == null) {
          this.toaster.success('Vehicle successfully registered.');
        } else {
          this.vehicleId = null;
          this.toaster.success('Vehicle successfully updated.');
        }
      }, error => {
        this.loader = false;
        this.primaryModal.hide();
        this.commonMethod.returnErrorMessage(error);
      }));
  }

  // Edit Vehicle
  editVehicle(vehicle) {
    this.vehicleCompanyName = vehicle.vehicleCompanyName;
    this.vehicleNo = vehicle.vehicleNo;
    this.vehicleId = vehicle.id;
    this.primaryModal.show();
  }



  // Modal

  clickDeleteModal(vehicle) {
    this.vehicleId = vehicle.id;
    this.vehicleNo = vehicle.vehicleNo;
    this.vehicleCompanyName = vehicle.vehicleCompanyName;
    this.primaryModal1.show();
  }

  clickOnVehicleButton() {
    this.vehicleId = null;
    this.vehicleCompanyName = null;
    this.vehicleNo = null;
    this.primaryModal.show();
  }



  deleteVehicleNo(): void {
    this.loader = true;
    this.subscribe.push(this.residentService.deleteVehicleInfo(this.vehicleId).subscribe(
      data => {
        this.loader = false;
        this.ngOnInit();
        this.primaryModal1.hide();
        this.toaster.success('Vehicle info deleted successfully.');
      }, error => {
        this.loader = false;
        this.primaryModal1.hide();
        this.commonMethod.returnErrorMessage(error);
      }));
  }



  // Regenrate QR CODE
  regenerateQRCode(vehicleId) {
    this.loader = true;
    this.subscribe.push(this.residentService.regenerateCommercialvehicleQRCode(vehicleId).subscribe(
      data => {
        this.loader = false;
        this.toaster.success('QR code re-generated successfully');
        this.ngOnInit();
      }, error => {
        this.loader = false;
        this.ngOnInit();
        this.commonMethod.returnErrorMessage(error);
      }));
  }

  // get QR CODE Image
  getImage(image): void {
    // if (time === null || time === '' || time === undefined || time === ' ') {
    //   this.expTime = '';
    // } else {
    //   this.expTime = time;
    // }
    this.subscribe.push(this.userService.getImageBase64(image).subscribe(
      data => {
        const wrapper = JSON.parse(JSON.stringify(data));
        if (wrapper.imageBase64 === undefined || wrapper.imageBase64 === '' || wrapper.imageBase64 === null) {
          this.imageName = 'No image found';
          this.toaster.error('No image found!!!');
        } else {
          this.primaryModal2.show();
          this.imageName = 'data:image/jpg;base64,' + wrapper.imageBase64;
        }
      }, error => {
        this.commonMethod.returnErrorMessage(error);
      }));
  }


  // Download the QR Code
  downloadQRCode(image): void {
    this.subscribe.push(this.userService.getImageBase64(image).subscribe(
      data => {
        const wrapper = JSON.parse(JSON.stringify(data));
        if (wrapper.imageBase64 === undefined || wrapper.imageBase64 === '' || wrapper.imageBase64 === null) {
          this.imageName = 'No image found';
          this.toaster.error('No image found!!!');
        } else {
          const a = document.createElement('a');
          a.href = 'data:image/png;base64,' + wrapper.imageBase64;
          a.download = 'QRCode.png';
          a.click();
        }
      }, error => {
        this.commonMethod.returnErrorMessage(error);
      }));
  }

  //  Import Vechile Detail 
  importCommercialVehicle(): void {
    this.route.navigate(['/home/vehicle/importVehicle']);
  }

  ngOnDestroy(): void {
    this.subscribe.forEach(destroyExistingValue => {
      destroyExistingValue.unsubscribe();
    });
  }

  //   pageChange(newPage: number) {
  //     this.route.navigate(['/home/vehicle/vehicleInfo'], { queryParams: { page: newPage } });
  // }

}

